import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import CompanionMaterialItem from '@/models/CompanionMaterialItem';
import CompanionMaterialItemConstants from '../CompanionMaterialItemConstants';
import ICompanionMaterialConversionHandler from './ICompanionMaterialConversionHandler';

class CalculatorCompanionMaterialConversionHandler implements ICompanionMaterialConversionHandler {
  execute(companionMaterialItem: CompanionMaterialItem): Map<string, unknown> {
    const map: Map<string, unknown> = new Map();
    if (
      companionMaterialItem &&
      companionMaterialItem.name === CompanionMaterialItemConstants.CALCULATOR &&
      companionMaterialItem.companionMaterialDetailItems.length === 1
    ) {
      map.set(DeliveryOptionConstants.CALCULATOR, companionMaterialItem.companionMaterialDetailItems[0].value);
    }

    return map;
  }
}

export default CalculatorCompanionMaterialConversionHandler;
